export default __webpack_public_path__ + "static/media/quiz-dark.2206029a.svg";